import React from "react";

export const ListViewBudget = ({ budgetData, categoryBudget }) => {
  return (
    <div style={{width:"50%"}}>
      {budgetData && budgetData.length > 0 ? (
        budgetData.map((item, index) => {
          const budgetValue =
            categoryBudget &&
            categoryBudget.length > 0 &&
            categoryBudget.find((budget) => {
              if (item.subCategoryId && budget.subCategoryId) {
                return budget.subCategoryId === item.subCategoryId;
              } else if (budget && budget.categoryId && !item.subCategoryId) {
                return budget.categoryId === item.categoryId;
              }
              return false;
            });
          const totalBudgetAmount =
            item.multipliedAmount !== undefined && item.multipliedAmount
              ? item.multipliedAmount
              : item.amount
              ? item.amount
              : 0;
          const amount =
            item.totalSpent !== undefined && item.multipliedAmount !== undefined
              ? item.multipliedAmount - item.totalSpent
              : budgetValue
              ? budgetValue.leftAmount
              : item.amount;
          const usedAmount =
            item.totalSpent !== undefined && item.totalSpent
              ? item.totalSpent
              : budgetValue
              ? budgetValue.usedAmount
              : 0;

          // Format amount as positive and add commas
          const formattedAmount = Math.abs(amount)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          const label = amount < 0 ? "Over" : "Left";

          return (
            <div
              key={index}
              className=""
              style={{
                gap: "1rem",
                marginTop: "8px",
              }}
            >
              <span className="budgetCardTitle">
                {item.subCategoryId
                  ? `${
                      item.budgetCategory && item.budgetCategory.categoryName
                    } (${
                      (
                        (item.budgetCategory &&
                          item.budgetCategory.subCategories &&
                          item.budgetCategory.subCategories.find(
                            (sub) => sub.id === item.subCategoryId
                          )) ||
                        {}
                      ).name
                    })`
                  : item.budgetCategory && item.budgetCategory.categoryName}
                {" (" +
                  (item.totalSpent !== undefined
                    ? `$${item.totalSpent
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                    : budgetValue && budgetValue && budgetValue.usedAmount
                    ? `$${budgetValue.usedAmount
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                    : "$" + (0).toFixed(2)) +
                  " of " +
                  (item.multipliedAmount !== undefined
                    ? `$${item.multipliedAmount
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                    : `$${item.amount
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`) +
                  ")"}
              </span>
              <span
                style={{
                  float: "right",
                  lineHeight: "28px",
                  marginLeft: "1rem",
                }}
              >
                ${formattedAmount} {label}
              </span>
              <div className="progress-container-budget">
                <div
                  className="progress-bar-budget2"
                  style={{
                    lineHeight: "16px",
                    background:
                      item && totalBudgetAmount
                        ? ((usedAmount || 0) / totalBudgetAmount) * 100 > 50
                          ? `linear-gradient(
                  90deg,
                  #00f710 ${
                    100 - ((usedAmount || 0) / totalBudgetAmount) * 100
                  }%,
                  #ff3939 ${((usedAmount || 0) / totalBudgetAmount) * 100}%
                )`
                          : `linear-gradient(
                  90deg,
                  #00f710 ${((usedAmount || 0) / totalBudgetAmount) * 100}%,
                  #00f710 100%
                )`
                        : "#00f710",
                    width:
                      item && totalBudgetAmount
                        ? `${((usedAmount || 0) / totalBudgetAmount) * 100}%`
                        : "0%", // Default to 0% if totalAmount or usedAmount is missing
                  }}
                >
                  $
                  {usedAmount
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </div>
                <div className="progress-bar-value-budget"></div>
              </div>
            </div>
          );
        })
      ) : (
        <div
          className="nodata"
          style={{
            width: "100%",
            textAlign: "center",
            marginTop: "2rem",
            fontSize: "18px",
          }}
        >
          No data to show
        </div>
      )}
    </div>
  );
};
